import SpriteSymbol from "../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-2001",
  "use": "icon-2001-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-2001\" viewBox=\"0 0 16 16\" id=\"icon-2001\">\n  <path d=\"M14.57 3.689s-6.977-2.06-9.323-2.672a.695.695 0 0 0-.836.497L1.028 14.121a.708.708 0 0 0 .476.847.71.71 0 0 0 .876-.485l1.462-5.45 10.829-4.214a.608.608 0 0 0-.101-1.13z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol